import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import FormulaUtilsTooling from '../../../tooling/formulaUtilsTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import { intl } from '../../../locales/localesConfig';

/* Actions */
import * as reportTemplateAdminActions from '../../actions/reportTemplateAdmin/index';
import * as formulaEditorActions from '../../actions/formulaEditor/index';
import * as dashboardActions from '../../actions/dashboard/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityHeader from '../../components/common/entity/entityHeader';
import EntityTable from '../../components/common/entity/entityTable';
import FormPopup from '../../components/reportTemplateAdmin/formPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import CheckBox from '../../components/common/inputs/checkBox';
import FormulaEditor from '../formulaEditor';
import MetricDetailColumnsEditorPopup from '../../components/reportTemplateAdmin/metricDetailColumnsEditorPopup';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';

const popupIds = {
  formPopup: "formPopup",
  formulaEditorPopup: "formulaEditorPopup",
  metricDetailColumnsEditorPopup: "metricDetailColumnsEditorPopup",
  closeFormulaConfirmPopup: "closeFormulaConfirmPopup",
  closeFormConfirmPopup: "closeFormConfirmPopup",
}

class ReportTemplateAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topControlsFormData: {
        searchText: '',
        showDisabledEntities: false,
        showOnlyModels: false
      },
      searchTimeoutObject: null,
      tableDescriptor: TableDescriptors.reportTemplateList,
      entityApiKey: "report_template",      
      initialNewEntity: { default: false, no_breadcrum: false, new_page_after_rich_description: false,
        hide_total: false, show_deep_tree: false, header: [], metrics_detail: [] },
      pendingSaveFields: {},
      formulaEditorOptions: {},
      metricDetailColumnsIndexToEdit: null,      
      metricDetailColumnsToEdit: null,
      metricDetailColumnsToEditMetricMetadata: null
    };
  }
 
  async componentDidMount() {
    EntityTableTooling.fetchList(this);
    await this.props.actions.getPolynomialsList();
    await this.props.actions.getPolynomialTablesList();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {
    EntityTableTooling.feedbackMessages(this, prevProps, 
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "reportTemplateAdmin.entityNameSingularWithArticle"})),
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "reportTemplateAdmin.entityNamePlural"})),
      intl.formatMessage({id: "reportTemplateAdmin.genderVocal"}),
      this.props.delete.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.delete.errors.message : "");
    
    //preload report template
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.preloadReportTemplate.status],
      [this.props.preloadReportTemplate.status],
      null,
      intl.formatMessage({ id: "common.errors.conectionError" }),
      [() => {
        let entityObject = {};
        entityObject[this.state.entityApiKey] = this.props.preloadReportTemplate.data;
        if(this.props.save.data && this.props.save.data["clone"]) {
          delete entityObject[this.state.entityApiKey]["id"];
        }
        this.props.actions.resetSaveEntity(entityObject);
      }]  
    );
    
    //handle formula validation
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.formulaValidation.status],
      [this.props.formulaValidation.status],
      intl.formatMessage({ id: "polynomialAdmin.formulaEditor.validateAndSetButtonSucces" }),
      this.props.formulaValidation.status!=422 ? 
        intl.formatMessage({ id: "common.errors.conectionError" }) : 
        intl.formatMessage({ id: "polynomialAdmin.formulaEditor.validateAndSetButtonError" }),
      [() => {
        let metricDetailPath = this.props.formulaValidation.data.finalPath.replace(".formula","");
        let metricDetailObject = JavascriptUtilsTooling.deepCopy(
          JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, metricDetailPath)
        );
        let metricDetailMetricNameOld = metricDetailObject.formula_lineal_array.length > 0 ? metricDetailObject.formula_lineal_array[0].name.toUpperCase() : null;
        let metricDetailMetricNameNew = this.props.formulaValidation.data.formulaArray.length > 0 ? this.props.formulaValidation.data.formulaArray[0].name.toUpperCase() : null;
        metricDetailObject.formula_lineal_array = this.props.formulaValidation.data.formulaArray;
        metricDetailObject.formula = this.props.formulaValidation.data.formula;
        if(metricDetailMetricNameOld != metricDetailMetricNameNew && metricDetailMetricNameOld != null) {
          metricDetailObject.dimension_columns_descriptor = [];
          metricDetailObject.values_columns_descriptor = [];
          metricDetailObject.virtual_columns_descriptor = [];
          metricDetailObject.group_by_descriptor = [];
          metricDetailObject.order_by_descriptor = [];
          metricDetailObject.transformations_descriptor = [];
        }
        let newPendingSaveFields = JavascriptUtilsTooling.deepCopy(this.state.pendingSaveFields);
        newPendingSaveFields[this.props.formulaValidation.data.finalPath] = true;
        this.setState({
          pendingSaveFields: newPendingSaveFields
        });
        this.props.actions.setSaveEntityDataByKey(metricDetailPath, metricDetailObject);
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.formulaEditorPopup])) {
          InterfaceTooling.popupHide(popupIds.formulaEditorPopup, this.setState.bind(this));
        }
      }]  
    );
  }
  
  handleOnChangeForm = (event) => {    
    if(event.currentTarget.dataset.objecteditor) {
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let objectValue = JSON.parse(event.currentTarget.dataset.value);
      let isDelete = event.currentTarget.dataset.delete;
      let isEdit = event.currentTarget.dataset.edit;
      let objectDefinition = [];
      
      if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)) {
        objectDefinition = JavascriptUtilsTooling.deepCopy(
          JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
        );
      }
      let newPendingSaveFields = null
      if(isDelete) { 
        if(path == "report_template.metrics_detail"){
          newPendingSaveFields = JavascriptUtilsTooling.deepCopy(this.state.pendingSaveFields);

          for(let newIndex = index; newIndex < objectDefinition.length; newIndex++) {
            if(newIndex == index) {
              newPendingSaveFields["report_template.metrics_detail." + newIndex + ".formula"] = null;
            }
            else if((newIndex > index)) {
              newPendingSaveFields["report_template.metrics_detail." + (+newIndex - 1) + ".formula"] = newPendingSaveFields["report_template.metrics_detail." + newIndex + ".formula"];
            }
          }
        }        
        delete objectDefinition[index];
        objectDefinition = objectDefinition.filter(item => item);
      } else if(isEdit) {
        objectDefinition[index] = objectValue;
      } else {
        objectDefinition.push(objectValue);
      }
      this.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path,objectDefinition);

      let currentPendingFields = newPendingSaveFields ? newPendingSaveFields : JavascriptUtilsTooling.deepCopy(this.state.pendingSaveFields);
      currentPendingFields[event.currentTarget.dataset.path] = true;
      this.setState({
        pendingSaveFields: currentPendingFields
      });
    }
    else {
      EntityTableTooling.handleOnChangeForm(this, event);
    }    
  };

  handleShowFormPopup = (event) => {
    InterfaceTooling.handleShowClosePopup(
      event, popupIds.formPopup, popupIds.closeFormConfirmPopup, this.state, 
      this.setState.bind(this), (this.props.save.loading || this.props.preloadReportTemplate.loading), () => {
        let entityObject = {};
        if(event.currentTarget.dataset.entitydata) {
          let parsedObject = JSON.parse(event.currentTarget.dataset.entitydata)
          entityObject[this.state.entityApiKey] = JavascriptUtilsTooling.deepCopy(this.state.initialNewEntity);
          this.props.actions.resetSaveEntity(entityObject);
          this.props.actions.getReportTemplate({
            id: parsedObject.id
          });
        }
        else {
          entityObject[this.state.entityApiKey] = JavascriptUtilsTooling.deepCopy(this.state.initialNewEntity);
          entityObject.isEmpty = true;
          this.props.actions.resetSaveEntity(entityObject);
        }
        this.setState({
          pendingSaveFields: {}
        });
      }
    );
  };

  handleShowFormPopupToClone = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.formPopup, this.state, 
      this.setState.bind(this), (this.props.save.loading || this.props.preloadReportTemplate.loading), () => {
        let entityObject = {};
        let parsedObject = JSON.parse(event.currentTarget.dataset.entitydata)
        entityObject[this.state.entityApiKey] = JavascriptUtilsTooling.deepCopy(this.state.initialNewEntity);
        entityObject["clone"] = true;
        this.props.actions.resetSaveEntity(entityObject);
        this.props.actions.getReportTemplate({
          id: parsedObject.id
        });
        this.setState({
          pendingSaveFields: {}
        });
      }
    );
  };

  handleShowFormulaEditorPopup = (event) => {
    InterfaceTooling.handleShowClosePopup(
      event, popupIds.formulaEditorPopup, popupIds.closeFormulaConfirmPopup, this.state, 
      this.setState.bind(this), false, () => {
        let path = event.currentTarget.dataset.path;
        let label = event.currentTarget.dataset.label;
        let disableMarkMode = event.currentTarget.dataset.disablemarkmode == "true" ? true : false;
        let disableFunctions = event.currentTarget.dataset.disablefunctions;
        let finalPath = event.currentTarget.dataset.finalpath;        
        let onlyRead = event.currentTarget.dataset.onlyread;        
        let formulaType = event.currentTarget.dataset.formulatype;
        let propsTarget = event.currentTarget.dataset.propstarget;
        propsTarget = propsTarget ? propsTarget : "save";
        disableFunctions = disableFunctions ? JSON.parse(disableFunctions) : []
        
        let formulaObject = {};      
        let formulaArray = [];
        if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props[propsTarget].data, path)) {
          formulaArray = JavascriptUtilsTooling.deepCopy(
            JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props[propsTarget].data, path)
          );
        }
        formulaObject.path = path;
        formulaObject.finalPath = finalPath;
        formulaObject.label = label;
        formulaObject.onlyRead = onlyRead;
        formulaObject.marks_list = {};
        formulaObject.formulaArray = formulaArray;
        formulaObject.formula_type = formulaType;
        this.props.formulaEditorActions.setFormulaToEditObject(FormulaUtilsTooling.changeCollapseAllEntity(formulaObject, "false"));
        this.setState({
          formulaEditorOptions: {
            disableMarkMode: disableMarkMode,
            disableFunctions: disableFunctions,
            formulaType: formulaType
          }
        });
      }
    );
  };

  handleShowMetricDetailColumnsEditorPopup = (event) => {
    this.setState({
      metricDetailColumnsIndexToEdit: null,
      metricDetailColumnsToEdit: null,
      metricDetailColumnsToEditMetricMetadata: null
    });
    InterfaceTooling.handleShowPopup(
      event, popupIds.metricDetailColumnsEditorPopup, this.state, 
      this.setState.bind(this), false, () => {
        let metricDetailIndex = event.currentTarget.dataset.metricdetailindex;
        let metricDetailObject = JavascriptUtilsTooling.deepCopy(
          JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, "report_template.metrics_detail." + metricDetailIndex)
        );
        let metricDetailMetricName = metricDetailObject.formula_lineal_array.length > 0 ? metricDetailObject.formula_lineal_array[0].name.toUpperCase() : null;
        let isCalculationMetric = metricDetailObject.formula_lineal_array.length > 0 && metricDetailObject.formula_lineal_array[0].virtual_calculation;
        
        let metricMetaData = metricDetailMetricName ? this.props.metricsList.data.find(metric => metric.name.toUpperCase() == metricDetailMetricName) : null;
        if(metricMetaData) {
          metricMetaData = {
            dimensionOptions: InterfaceTooling.getSelectArrayFromArrayOfObjects(metricMetaData.dimension_hash.map(dimItem => ({id: "id" + dimItem.id, name: dimItem.name})), "id", "name"),
            valueOptions: metricMetaData.object_definition ? InterfaceTooling.getSelectArrayFromArrayOfObjects(metricMetaData.object_definition, "id", "name") : InterfaceTooling.getSelectArray("selectKeys.reportMetricsDetail.onlyValueSelect","reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.onlyValueOptions")
          }
        }
        //if it is a calculation metric metricMetaData is going to be null so, we make the
        // metricMetadata object for this case
        if(isCalculationMetric && metricDetailObject.formula_lineal_array[0].childs.length > 0) {
          metricMetaData = {
            dimensionOptions: InterfaceTooling.getSelectArrayFromArrayOfObjects(metricDetailObject.formula_lineal_array[0].childs.filter(dimItem => dimItem.id).map(dimItem => ({id: "id" + dimItem.id, name: dimItem.name})), "id", "name"),
            valueOptions: InterfaceTooling.getSelectArray("selectKeys.reportMetricsDetail.onlyValueSelect","polynomialAdmin.formulaEditor.virtualCalculationOrderColumnsLabels.onlyValueOptions"),
            virtualCalculation: true
          }
        }
        
        this.setState({
          metricDetailColumnsIndexToEdit: metricDetailIndex,
          metricDetailColumnsToEdit: metricDetailObject,
          metricDetailColumnsToEditMetricMetadata: metricMetaData ? metricMetaData : null
        });
      }
    );
  };

  handleOnChangeMetricDetailColumnsForm = (event) => {    
    let path = event.currentTarget.dataset.path;
    let columnType = event.currentTarget.dataset.columntype;
    let index = event.currentTarget.dataset.index;
    let objectValue = JSON.parse(event.currentTarget.dataset.value);
    let isDelete = event.currentTarget.dataset.delete;
    let isEdit = event.currentTarget.dataset.edit;
    let newMetricDetailColumnsToEdit = JavascriptUtilsTooling.deepCopy(this.state.metricDetailColumnsToEdit);
    if(!(path in newMetricDetailColumnsToEdit)) {
      newMetricDetailColumnsToEdit[path] = [];
    }
    let objectDefinition = newMetricDetailColumnsToEdit[path];

    if(isDelete) { 
      delete objectDefinition[index];
      newMetricDetailColumnsToEdit[path] = objectDefinition.filter(item => item);
    } else if(isEdit) {
      objectDefinition[index] = objectValue;
    } else {
      if(columnType) {
        objectValue.type = columnType;
      }
      objectDefinition.push(objectValue);
    }
    this.setState({
      metricDetailColumnsToEdit: newMetricDetailColumnsToEdit
    });
  };

  handleSaveMetricDetailColumnsEditorPopup = (event) => {
    if(InterfaceTooling.popupHasToRender(this.state[popupIds.metricDetailColumnsEditorPopup])) {
      InterfaceTooling.popupHide(popupIds.metricDetailColumnsEditorPopup, this.setState.bind(this));
    }
    let metricDetails = JavascriptUtilsTooling.deepCopy(
      JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, "report_template.metrics_detail")
    );
    let newPendingSaveFields = JavascriptUtilsTooling.deepCopy(this.state.pendingSaveFields);
    newPendingSaveFields["report_template.metrics_detail." + this.state.metricDetailColumnsIndexToEdit + ".formula"] = true;
    metricDetails[this.state.metricDetailColumnsIndexToEdit] = this.state.metricDetailColumnsToEdit;

    this.setState({
      metricDetailColumnsIndexToEdit: null,
      metricDetailColumnsToEdit: null,
      metricDetailColumnsToEditMetricMetadata: null,
      pendingSaveFields: newPendingSaveFields
    });
    this.props.actions.setSaveEntityDataByKey("report_template.metrics_detail", metricDetails);
  };

  handleCloneMetricDetail = (event) => {
    let metricDetails = JavascriptUtilsTooling.deepCopy(
      JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, "report_template.metrics_detail")
    );
    let metricDetailsLength = metricDetails.length;
    let clonedMetricDetail = JavascriptUtilsTooling.deepCopy(metricDetails[event.currentTarget.dataset.index]);
    
    let newMetricsDetail = []
    metricDetails.forEach((metricDetail, index) => {
      if(index == event.currentTarget.dataset.index) {
        newMetricsDetail.push(clonedMetricDetail);
      }
      newMetricsDetail.push(JavascriptUtilsTooling.deepCopy(metricDetail));
    });

    this.props.actions.setSaveEntityDataByKey("report_template.metrics_detail", newMetricsDetail);

    let currentPendingFields = JavascriptUtilsTooling.deepCopy(this.state.pendingSaveFields);
    let newPendingSaveFields = JavascriptUtilsTooling.deepCopy(currentPendingFields);

    for(let newIndex = event.currentTarget.dataset.index;newIndex<=metricDetailsLength;newIndex++){
      if(newIndex == (event.currentTarget.dataset.index)) {
        newPendingSaveFields["report_template.metrics_detail." + (+newIndex + 1) + ".formula"] = true;
      }
      else {
        newPendingSaveFields["report_template.metrics_detail." + (+newIndex + 1) + ".formula"] = currentPendingFields["report_template.metrics_detail." + newIndex + ".formula"]
      }
    }

    this.setState({
      metricDetailColumnsIndexToEdit: null,
      metricDetailColumnsToEdit: null,
      metricDetailColumnsToEditMetricMetadata: null,
      pendingSaveFields: newPendingSaveFields
    });
  }

  render() {
    var loadingView = this.props.list.firstLoading ||
        this.props.polynomialsList.firstLoading ||
        this.props.polynomialTablesList.firstLoading;
    var errorLoadingView = (this.props.list.status !== null && this.props.list.status !== 200) ||
        (this.props.polynomialsList.status !== null && this.props.polynomialsList.status !== 200) ||
        (this.props.polynomialTablesList.status !== null && this.props.polynomialTablesList.status !== 200);
    return (
      <section className="dashboard_content_inner_view entity_admin_container report_template_admin_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) : 
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section>
              <EntityHeader 
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleFormPopup={this.handleShowFormPopup}
                handleRefresh={EntityTableTooling.fetchList.bind(null, this)}
              />
              <EntityTable
                entityTableDescriptor={this.state.tableDescriptor}
                data={this.props.list.data}
                loading={this.props.list.loading}
                page={this.props.list.page}
                totalPages={this.props.list.totalPages}
                totalRecords={this.props.list.totalRecords}
                orderBy={this.props.list.orderBy}
                orderByDirection={this.props.list.orderByDirection}
                topControlsFormData={this.state.topControlsFormData}
                handleOnChangeTopControls={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                fetchOrderList={EntityTableTooling.fetchListOrder.bind(null, this)}
                fetchListChangePage={EntityTableTooling.fetchListNextPage.bind(null, this)}
                handleShowFormPopup={this.handleShowFormPopup}
                handleDelete={EntityTableTooling.handleDeletePopup.bind(null, this)}
                handleActive={EntityTableTooling.handleActivePopup.bind(null, this)}
                handleCustomActions={[this.handleShowFormPopupToClone]}
                customActionsIcons={["clone"]}
                customActionsTooltips={[
                  intl.formatMessage({ id: "reportTemplateAdmin.cloneButton"})
                ]}
              />
              <FormPopup
                handleShowPopup={this.handleShowFormPopup}
                handleOnChangeForm={this.handleOnChangeForm}
                handleButton={EntityTableTooling.handleOnSaveForm.bind(null, this)}
                loadingButton={this.props.save.loading}
                fullLoading={this.props.save.loading || this.props.preloadReportTemplate.loading ||
                  this.props.metricsList.loading || this.props.metricsList.firstLoading ||
                  this.props.saveUserImage.loading}
                statusPreloading={this.props.preloadReportTemplate.status}
                loadingPreloading={this.props.preloadReportTemplate.loading}
                pendingSaveFields={this.state.pendingSaveFields}
                statusButton={this.props.save.status}
                modelsData={this.props.polynomialsList.data}
                tablesData={this.props.polynomialTablesList.data}
                formData={this.props.save.data}
                errors={this.props.save.errors}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleEditFormulaLink={this.handleShowFormulaEditorPopup}
                handleEditMetricDetailColumnsLink={this.handleShowMetricDetailColumnsEditorPopup}
                handleSaveUserImage={this.props.dashboardActions.saveUserImage}
                handleCloneDetail={this.handleCloneMetricDetail}
                popupState={EntityTableTooling.getFormPopupState(this)}
              />
              <FormulaEditor
                handleShowFormulaEditorPopup={this.handleShowFormulaEditorPopup}
                formulaEditorOptions={this.state.formulaEditorOptions}
                popupState={this.state[popupIds.formulaEditorPopup]}
              /> 
              <MetricDetailColumnsEditorPopup
                handleShowPopup={this.handleShowMetricDetailColumnsEditorPopup}
                handleOnChangeForm={this.handleOnChangeMetricDetailColumnsForm}
                handleButton={this.handleSaveMetricDetailColumnsEditorPopup}
                metricDetailColumnData={this.state.metricDetailColumnsToEdit}
                metricDetailColumnsMetricMetadata={this.state.metricDetailColumnsToEditMetricMetadata}
                popupState={this.state[popupIds.metricDetailColumnsEditorPopup]}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirmTitle"}
                 values={{entityNameSingular: (<FormattedMessage id={"reportTemplateAdmin.entityNameSingular"}/>)}}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirm"}
                 values={{entityNameSingular: (<FormattedMessage id={"reportTemplateAdmin.entityNameSingularWithArticle"}/>)}}
                />)}
                handleConfirm={EntityTableTooling.handleDeleteConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleDeletePopup.bind(null, this)}
                popupState={EntityTableTooling.getDeletePopupState(this)}
                loading={this.props.delete.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirmTitle"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"reportTemplateAdmin.entityNameSingular"}/>),
                    activeAction: this.props.save.data.report_template && this.props.save.data.report_template.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirm"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"reportTemplateAdmin.entityNameSingularWithArticle"}/>),
                    activeAction: this.props.save.data.report_template && this.props.save.data.report_template.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                handleConfirm={EntityTableTooling.handleActiveConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleActivePopup.bind(null, this)}
                popupState={EntityTableTooling.getActivePopupState(this)}
                loading={this.props.save.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"polynomialAdmin.formulaEditor.closePopupTitle"}/>)}
                confirmText={(<FormattedMessage id={"polynomialAdmin.formulaEditor.closePopupDetail"}/>)}
                handleConfirm={InterfaceTooling.handleCloseFormula.bind(null, this)}
                handleCancel={InterfaceTooling.handleCloseFormulaConfirmPopup.bind(null, this)}
                popupState={InterfaceTooling.getCloseFormulaConfirmPopupState(this)}
                loading={false}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"polynomialAdmin.closePopupTitle"}/>)}
                confirmText={(<FormattedMessage id={"polynomialAdmin.closePopupDetail"}/>)}
                handleConfirm={InterfaceTooling.handleCloseForm.bind(null, this)}
                handleCancel={InterfaceTooling.handleCloseFormConfirmPopup.bind(null, this)}
                popupState={InterfaceTooling.getCloseFormConfirmPopupState(this)}
                loading={false}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  list: state.reducer.reportTemplateAdmin.list,
  preloadReportTemplate: state.reducer.reportTemplateAdmin.preloadReportTemplate,  
  save: state.reducer.reportTemplateAdmin.save,
  delete: state.reducer.reportTemplateAdmin.delete,
  polynomialsList: state.reducer.reportTemplateAdmin.polynomialsList,
  polynomialTablesList: state.reducer.reportTemplateAdmin.polynomialTablesList,  
  metricsList: state.reducer.formulaEditor.metricsList,
  formulaValidation: state.reducer.formulaEditor.formulaValidation,
  saveUserImage: state.reducer.dashboard.saveUserImage
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(reportTemplateAdminActions, dispatch),
  formulaEditorActions: bindActionCreators(formulaEditorActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

ReportTemplateAdmin.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportTemplateAdmin);



// WEBPACK FOOTER //
// ./source/client/containers/reportTemplateAdmin/index.jsx